
import React, {useContext, useEffect, useRef} from 'react';
import {
    PlayerContext,
    SMALL,
} from "../PlayerReducer";

import classnames from 'classnames';

export default (props:{
                    countPerPage: number,
                    position: number,
                    setPosition: (position: number)=> void
                })=>{

    const intervalRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(()=>{
        return ()=>{
            if (intervalRef.current)
                clearTimeout(intervalRef.current);
        }
    },[])

    const player = useContext(PlayerContext);

    const  { stations, size, status} = player;

    let pages = 0;

    if (props.countPerPage) {
        if (size === SMALL) {
            pages = Math.ceil(stations.length / props.countPerPage);
        } else {
            pages = Math.ceil((stations.length / 2) / props.countPerPage);
        }
    }

    useEffect(()=>{

        if (intervalRef.current)
            clearTimeout(intervalRef.current);

        if (status === 'STOP' && pages)
        {
            intervalRef.current = setTimeout(()=>{
                let newposition = props.position + 1;
                if (pages <= newposition)
                    newposition = 0;
                props.setPosition(newposition);

            }, 5000)
        }
        else if (intervalRef.current) {
            clearTimeout(intervalRef.current)
        }
    }, [status, props.position, pages]);




    if (props.countPerPage <=0)
        return <div className={'radiacz-slide'}/>;

    const output:JSX.Element[] = [];

    for (let i = 0; i < pages; i++)
    {
        const j = i;
        if (j == 0 && pages > 1)
        {

            output.push(<a key={'left'} href={'#'} onClick={(ev)=>{
                ev.preventDefault();
                if (intervalRef.current)
                    clearTimeout(intervalRef.current);
                props.setPosition(props.position-1 >= 0 ? props.position-1: 0);
            }} className={'radiacz-arrow radiacz-arrow-left'}><span>left</span></a>);
        }

        output.push(<a key={j} className={classnames({
            'radiacz-dot': true,
            'selected': props.position == j
        })} onClick={(ev)=>{
            ev.preventDefault();
            if (intervalRef.current)
                clearTimeout(intervalRef.current);
            props.setPosition(j);
        }}><span>{i+1}</span></a>);

        if (j+1 == pages && pages > 1 )
        {
            output.push(<a key={'right'} href={'#'} className={'radiacz-arrow'} onClick={(ev)=>{
                ev.preventDefault();
                if (intervalRef.current)
                    clearTimeout(intervalRef.current);
                props.setPosition(props.position+1 < pages ? props.position+1: pages-1);
            }}><span>right</span></a>);
        }
    }

    return <div className={'radiacz-slide'}>{output}</div>;
}